import React from 'react'
import styles from '../styles/OptionsModal.module.css'

const OptionsModalOption = ({ icon, title, description, onClick, dataTestId, rowHeight = '100px', iconSize = 40 }) => {
  return (
    <div
      className={`${styles.shareOptionsModalOption} d-flex align-items-center justify-content-between p-2 border rounded mt-3 gap-3 px-3`}
      style={{ height: rowHeight, cursor: 'pointer' }}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
      onClick={onClick}
    >
      <div className="d-flex flex-column justify-content-center w-auto">
        <div className="d-flex align-items-center">
          <img src={icon} alt={title} height={iconSize} width={iconSize} className="me-3" />
          <div className="d-flex flex-column">
            <h6 className="mb-0 fw-bold">{title}</h6>
            <div className="small text-muted">{description}</div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <img alt="tick" src="/assets/icons/left.png" height={32} width={32} style={{ transform: 'scaleX(-1)' }} />
      </div>
    </div>
  )
}

export default OptionsModalOption
